import useLogin from "@/Pages/Login/hooks/useLogin";
import { ButtonBase, ModalWrapper } from "@repo/ui/index.tsx";
import { useEffect, useState } from "react";

const InactivityModal = ({
  isOpen,
  handleClose,
}: {
  isOpen: boolean;
  handleClose: () => void;
}) => {
  const timerDuration = 1 * 60; // 1 min
  const [timeLeft, setTimeLeft] = useState<number>(timerDuration); // 1 min
  const {
    mutations: { logoutMutation },
    functions: { handleLogout },
  } = useLogin();

  useEffect(() => {
    if (!isOpen) return;

    // Reset timer when modal opens
    setTimeLeft(timerDuration);

    const interval = setInterval(() => {
      setTimeLeft((prev) => {
        if (prev <= 1) {
          clearInterval(interval);
          handleLogout();
          return 0;
        }
        return prev - 1;
      });
    }, 1000);
    return () => clearInterval(interval);
  }, [isOpen, timerDuration]);

  const minutes = Math.floor(timeLeft / 60);
  const seconds = timeLeft % 60;
  const formattedTime = `${String(minutes).padStart(2, "0")}:${String(seconds).padStart(2, "0")}`;
  return (
    <ModalWrapper
      isOpen={isOpen}
      handleCloseModal={handleClose}
      title=" Inactivitiy detected"
      containerClass="!min-w-[500px] w-[500px] p-2"
    >
      <div className="flex flex-col items-start gap-4">
        <p className="text-sm text-body font-medium">
          We have detected inactivity on your account. For security purposes,
          you will be logged out automatically.
        </p>

        <p className="bg-body/10 p-2 w-full rounded text-center text-xl font-extrabold">
          {formattedTime}
        </p>
        <p className="text-body text-xs font-bold">
          Time remaining before automatic logout
        </p>

        <ButtonBase
          buttonType="tertiary"
          text="Logout Now"
          className="bg-error w-full p-2 text-white"
          isLoading={logoutMutation.isPending}
          onClick={handleLogout}
        />
      </div>
    </ModalWrapper>
  );
};

export default InactivityModal;
